import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, onBeforeMount } from "vue";
import { useNewsFilter, useI18n, useConfig, isTopicFilterEnabled } from "./features";
import Layout from "./components/TheLayout.vue";
import Loader from "./components/TheLoader.vue";
import Form from "./components/TheForm.vue";
import NewsList from "./components/NewsList.vue";
import FilterContainer from "./components/FilterContainer.vue";
import TopicFilter from "./components/TopicFilter.vue";
import DateFilter from "./components/DateFilter.vue";
import FilterActiveZone from "./components/FilterActiveZone.vue";
import NewsListMoreButton from "./components/NewsListMoreButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const { fetchNews, displayedItems } = useNewsFilter();
        const { setLocale } = useI18n();
        const { setConfig, enableDateFilter, enableTopicFilter } = useConfig();
        onBeforeMount(() => {
            const enableTopicFilter = isTopicFilterEnabled(window.config);
            setLocale(window.config?.lng);
            setConfig({
                thema: window.config?.thema,
                frontendPath: window.config?.frontendPath,
                topics: window.config?.topics,
                pastYears: window.config?.pastYears,
                dateTill: window.config?.dateTill,
                noHitTxt: window.config?.noHitTxt,
                enableTopicFilter,
                enableDateFilter: window.config?.enableDateFilter,
                archive: window.config?.archive
            });
        });
        onMounted(async () => {
            await fetchNews({
                url: window.config?.jsonUrl,
                pastYears: window.config?.pastYears,
                archive: window.config?.archive,
                mandatoryTopics: window.config?.mandatoryTopics
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Layout, null, {
                default: _withCtx(() => [
                    _createVNode(Form, null, {
                        default: _withCtx(() => [
                            _createVNode(FilterContainer, null, {
                                toolbar: _withCtx(() => [
                                    _createVNode(TopicFilter, { enable: _unref(enableTopicFilter) }, null, 8 /* PROPS */, ["enable"]),
                                    _createVNode(DateFilter, { enable: _unref(enableDateFilter) }, null, 8 /* PROPS */, ["enable"])
                                ]),
                                "active-zone": _withCtx(() => [
                                    _createVNode(FilterActiveZone)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(Loader),
                            _createVNode(NewsList, {
                                items: _unref(displayedItems) || []
                            }, null, 8 /* PROPS */, ["items"]),
                            _createVNode(NewsListMoreButton)
                        ], undefined, true),
                        _: 1 /* STABLE */
                    })
                ], undefined, true),
                _: 1 /* STABLE */
            }));
        };
    }
});
